module.exports = __webpack_public_path__ + "static/media/sktm.f8ff349d.png";